import core from './commuCore'

export function getCommentaryPage (data) {
  return core.ajax(data, '/video/page', 'GET')
}

export function createCommentary (data) {
  return core.ajax(data, '/video/', 'POST')
}

export function deleteCommentary (data) {
  return core.ajax(data, '/video/', 'DELETE')
}

export function updateCommentary (data) {
  return core.ajax(data, '/video/', 'PUT')
}

export function getUploadAddress (data) {
  return core.ajax(data, '/video/getUploadAddress', 'GET')
}
export function refreshUploadAddress (data) {
  return core.ajax(data, '/video/refreshUploadAddress', 'GET')
}
export function fileUploadComplete (data) {
  return core.ajax(data, '/video/fileUploadComplete', 'GET')
}
export function deleteVideo (data) {
  return core.ajax(data, '/video/deleteVideo', 'PUT')
}
export function detail (data) {
  return core.ajax(data, '/video/detail', 'GET')
}
export function getPlayUrl (data) {
  return core.ajax(data, '/video/getPlayUrl', 'GET')
}
export function getTransCode (data) {
  return core.ajax(data, '/video/getTransCode', 'GET')
}
